import React from "react";
import Box from "@mui/material/Box";    


function Legends({series}){
    return (
        <Box sx={{display: 'flex',
            justifyContent: 'flex-start',
            margin: 'auto',
            flexWrap: 'wrap',
            width: "100%",
        }}>
            {series.map((s) => 
                <Box key={s.name} 
                    sx={{ display: "flex",
                    alignItems: "start",
                    lineHeight: "1.20rem",
                    marginLeft: ".75rem",
                }}>
                    <Box sx={{ width: "24px",
                        height: "24px",
                        marginRight: "8px",
                        marginTop: "8px",
                        backgroundColor: s.color }} 
                    />
                    <span style={{color: '#717177', minWidth: '110px', marginTop: "8px",}}>{s.name}</span>
                </Box>
            )}
        </Box>
    );
}


export { Legends };